module.exports = __webpack_public_path__ + "static/media/edit.3adbb3c8.svg";